import { render, staticRenderFns } from "./DetailsVirtualTv.vue?vue&type=template&id=22fee188&scoped=true&"
import script from "./DetailsVirtualTv.vue?vue&type=script&lang=js&"
export * from "./DetailsVirtualTv.vue?vue&type=script&lang=js&"
import style0 from "./DetailsVirtualTv.vue?vue&type=style&index=0&id=22fee188&prod&scoped=true&lang=css&"
import style1 from "./DetailsVirtualTv.vue?vue&type=style&index=1&id=22fee188&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fee188",
  null
  
)

export default component.exports